<template>
  <div class="content" >
    <vue-friendly-iframe
      ref="frame"
      border="0"
      class="imd_frame"
       @load="onLoad"
      :src=iframe.url
      :style="{height: iframe.height + 'px'}"
    />
       <!-- @document-load="onDocumentLoad" -->
      <!-- :style="{height: this.height + 'px'}" -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      iframe : '',
      height: 300,
    }
  },
  watch: {
    '$route': 'setIframe',
  },
  created() {
    this.setIframe()
  },
  methods: {
    setIframe() {
      this.iframe = this.getPath()
    },
    getPath() {
      switch (this.$route.path) {
        case '/member/info/customerpersonal': return { height: 4510,  url: 'https://www.seoulbar.or.kr/EgovPageLink.do?link=/site/customer/CustomerPersonal&frame=1' }
        case '/member/info/customerclause'  : return { height: 3778,  url: 'https://www.seoulbar.or.kr/EgovPageLink.do?link=/site/customer/CustomerClause&frame=1' }
        case '/member/info/customersite'    : return { height: 530,  url: 'https://www.seoulbar.or.kr/EgovPageLink.do?link=/site/customer/CustomerSite&frame=1' }
        case '/member/info/customeremail'   : return { height: 530,  url: 'https://www.seoulbar.or.kr/EgovPageLink.do?link=/site/customer/CustomerEmail&frame=1' }
      }
    },
    onLoad(e) {
      console.log("onLoad 1 = ", this.$refs.frame.iframeEl.contentWindow.document.body.offsetHeight);
      console.log("onLoad 2 = ", this.$refs.frame.iframeEl.contentWindow.document.body.scrollHeight);
      console.log("onLoad 3 = ", this.$refs.frame.iframeEl.contentWindow.document.body.clientHeight);
      console.log("onLoad 4 = ", this.$refs.frame.iframeEl.contentWindow.document.body.scrollTop );
      console.log("onLoad 4 = ", this.$refs.frame.iframeEl.contentWindow.document.body.height);
      // this.$refs.frame.iframeEl.style.border = "none"
      // this.$refs.frame.iframeEl.style.color = 'red'
      // this.$refs.frame.iframeEl.style.height = "50px"
      // console.log("sh1 " + this.$refs.frame.iframeEl.style.height);
      // console.log("sh2 " + this.$refs.frame.iframeEl.scrollHeight);
      // console.log("sh3 " + this.$refs.frame.iframeEl.clientHeight);
      // console.log("sh3 " + this.$refs.frame.$el.clientHeight);
      // console.log("sh3 " + this.$refs.frame.$el.scrollHeight);
      // this.height = this.$refs.frame.iframeEl.contentWindow.document.body.scrollHeight

    },
    resizeIframe(obj) {
      obj.style.height = obj.contentWindow.document.body.scrollHeight + 'px';
    },
  },
}
</script>

<style>
.imd_frame iframe { border: 0;}
</style>